import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// TODO refactor, use the same way of sending error messages as on phone and dates
export const matchPasswordsValidator = (field1: string, field2: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const field1Control = control.get(field1);
    const field2Control = control.get(field2);

    if (!field1Control || !field2Control) {
      return null;
    }

    const passwordsDoNotMatch = field1Control.value !== field2Control.value;

    if (passwordsDoNotMatch) {
      const field1Errors = {
        ...field1Control.errors,
        passwordMismatch: true,
      };
      const field2Errors = {
        ...field2Control.errors,
        passwordMismatch: true,
      };

      if (!field1Control.errors?.['passwordMismatch']) {
        field1Control.setErrors(field1Errors);
      }
      if (!field2Control.errors?.['passwordMismatch']) {
        field2Control.setErrors(field2Errors);
      }

      return { passwordMismatch: true };
    } else {
      // If the passwords match (no error), we remove the `passwordMismatch` error but keep other errors
      if (field1Control.errors?.['passwordMismatch']) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { passwordMismatch, ...otherErrors } = field1Control.errors;
        field1Control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }

      if (field2Control.errors?.['passwordMismatch']) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { passwordMismatch, ...otherErrors } = field2Control.errors;
        field2Control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }

      return null;
    }
  };
};
